const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 })

const formatCurrency = (value) => formatter.format(value)

export default formatCurrency



// WEBPACK FOOTER //
// ./src/utils/formatters/formatCurrency.js